/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from 'store/store';
import * as MyTv from 'store/ducks/myTv';
import { Rail } from 'ui/components';
import { RailMetaData } from 'ui/pages/myTv/MainPage';
import { Asset, EntryPoint } from '@wit/vtv-x-foundation-lib';
import * as BadgesStoreUtils from 'store/utils/badgesStoreUtils';
import BADGES_PRIORITY_PER_SECTION_RAIL from 'configs/BadgesPriorities';
import { useRouter } from '../../../hooks/useRouter';

interface Props {
  rail: RailMetaData;
}

export default function MyTVSubscription({ rail }: Props) {
  const dispatch = useDispatch();
  const router = useRouter();

  const { id, channelId } = rail.item;

  useEffect(() => {
    if (channelId && id) {
      dispatch(MyTv.ActionCreators.getFolderAssets(id, channelId));
    }
  }, [channelId, dispatch, id]);

  const isProcessed = useSelector((state: StoreState) => MyTv.Selectors.isFolderAssetsProcessed(state, id, channelId));
  const assets = useSelector((state: StoreState) =>
    BadgesStoreUtils.Selector.getAssetsWithBadges(
      state,
      BADGES_PRIORITY_PER_SECTION_RAIL.MY_TV.SUBSCRIPTION_RAIL,
      (store) => MyTv.Selectors.getFolderAssets(store, id, channelId),
      EntryPoint.SUBSCRIPTIONS
    )
  );

  if (!isProcessed) {
    return <></>;
  }

  const onCardClick = (asset: Asset) => {
    router.push({ asset });
  };

  return isProcessed && assets && assets.length !== 0 ? (
    <Rail
      railId={rail.item.id}
      // menuItemId => don't send menu item here since the folders menu item is not part of the original menu
      className="no-background"
      railName={rail.item.name}
      channelId={rail.item.channelId}
      assets={assets}
      onCardClick={onCardClick}
    />
  ) : null;
}
